// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2m_cv","item":"PaymentsMobile_item__3euBJ","label":"PaymentsMobile_label__1CDIm","amount":"PaymentsMobile_amount__18fvT"};